<template>
  <vs-card v-if="showComponent">
    <div slot="header">
      <h3>{{ title }}</h3>
    </div>

    <!-- Galeria de fotos e documentos-->
    <div>
      <div v-if="listArquivos.length == 0" class="p-5">
        <h6>Não há fotos ou documentos a serem exibidos.</h6>
      </div>

      <div v-else class="vx-row">
        <div
          class="vx-col lg:w-1/2 xl:w-1/4 w-full mt-5"
          v-for="arquivo in listArquivos"
          :key="arquivo.idEventoFoto"
        >
          <vs-card :class="{ remove: arquivo.deletar }">
            <div class="flex justify-between">
              <div class="p-2 break-all">
                <!-- Legenda -->
                <p>
                  {{ arquivo.legenda ? arquivo.legenda : arquivo.nome }}
                </p>
                <!-- Data e Hora -->
                <p>
                  {{ formatDateHour(arquivo.updatedAt) }}
                </p>
                <!-- Usuario -->
                <p>
                  {{ arquivo.nomeUsuario }}
                </p>
              </div>

              <div class="flex">
                <!-- Seleciona para Exclusão -->
                <vs-button
                  v-if="arquivo.deletar"
                  v-tooltip="'Deletar arquivo'"
                  type="gradient"
                  color="success"
                  icon="undo"
                  size="small"
                  @click="undoArquivoToDelete(arquivo)"
                ></vs-button>

                <!-- Desfazer seleção da Exclusão -->
                <vs-button
                  v-else
                  v-tooltip="'Deletar arquivo'"
                  type="gradient"
                  color="danger"
                  icon="close"
                  size="small"
                  @click="selectArquivoToDelete(arquivo)"
                ></vs-button>
              </div>
            </div>

            <!-- Preview -->
            <div>
              <!-- PDF -->
              <a
                v-if="isPdf(arquivo.nome)"
                class="flex justify-center"
                :href="arquivo.nome"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="w-1/2"
                  src="../../../../../assets/images/elements/PDF_file_icon2.png"
                />
              </a>

              <!-- Imagem -->
              <img
                v-else
                @click="openModalDetalhes(arquivo)"
                class="w-full cursor-pointer"
                :src="arquivo.nome"
              /></div
          ></vs-card>
        </div>
      </div>

      <!-- Aviso do limite de fotos -->
      <div v-if="listArquivos.length >= 40">
        <vs-alert title="Atenção" active="true" color="danger">
          Você chegou ao limite máximo de 40 fotos. Favor remover fotos atuais
          para poder acrescentar novas fotos.
        </vs-alert>
      </div>

      <!-- Botão Upload e Deletar-->
      <div class="flex justify-between items-center mt-5 lg:flex-row flex-col">
        <div class="p-5">
          <span class="colorBlue"
            >Limite de fotos: {{ listArquivos.length }} / 40</span
          >
        </div>
        <div class="flex gap-3 lg:flex-row flex-col">
          <!-- Deletar -->
          <vs-button
            color="danger"
            :disabled="!listArquivosToDelete.length"
            @click="deleteRegistroArquivos()"
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="Trash2Icon" />
              <span
                >Deletar: {{ listArquivosToDelete.length }} arquivos
                selecionados
              </span>
            </div></vs-button
          >

          <!-- Upload -->
          <vs-button
            @click="openModalUpload(idReferente)"
            :disabled="listArquivos.length >= 40"
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="UploadIcon" />Upload
            </div></vs-button
          >
        </div>
      </div>

      <!-- ######### START MODAIS #########-->
      <!-- Modal selecionar fotos e documentos -->
      <Modal
        title="Fotos e Documentos"
        :active.sync="modalFotoAtivo"
        fullscreen
      >
        <div v-if="itemModalSelecionado">
          <div class="flex justify-center m-5">
            {{
              itemModalSelecionado.legenda
                ? itemModalSelecionado.legenda
                : itemModalSelecionado.nome
            }}
          </div>
          <div class="flex justify-center">
            <img :src="itemModalSelecionado.nome" />
          </div>
        </div>
      </Modal>

      <!-- Modal Upload de fotos e documentos -->
      <Modal
        :title="this.titleModalUpload"
        :active.sync="modalUploadAtivo"
        :id="`idReferente${idReferente}`"
      >
        <!-- Fotos selecionadas -->
        <div v-if="!listArquivosToUpload.length" class="m-5 mb-10">
          <h5>Não há arquivos selecionados</h5>
        </div>
        <div v-else class="flex flex-wrap">
          <div
            v-for="(arquivo, index) in listArquivosToUpload"
            :key="index"
            class="lg:w-1/2 w-full p-5"
          >
            <vs-card>
              <div class="flex justify-end">
                <vs-button
                  v-tooltip="'Deletar arquivo'"
                  type="gradient"
                  color="danger"
                  icon="close"
                  size="small"
                  class="mb-2"
                  @click="deleteArquivoUpload(index)"
                ></vs-button>
              </div>

              <div class="flex justify-center">
                <img
                  v-if="isPdf(arquivo.nome)"
                  class="w-1/2"
                  src="../../../../../assets/images/elements/PDF_file_icon2.png"
                />
                <img v-else class="w-full" :src="arquivo.url" />
              </div>

              <div class="mt-2">
                <vs-input
                  label="Legenda do arquivo:"
                  class="w-full"
                  :value="arquivo.legenda"
                  @change="updateLegendaArquivo(arquivo, $event.target.value)"
                ></vs-input>
              </div>
            </vs-card>
          </div>
        </div>
        <div
          v-if="listArquivosToUpload.length + listArquivos.length >= 40"
          class="mb-3"
        >
          <vs-alert title="Atenção" active="true" color="danger">
            <span v-if="listArquivos.length"
              >Você já possui {{ listArquivos.length }} fotos salvas.</span
            >
            Subindo essas fotos, você chegará ao limite total máximo de 40
            fotos. Favor remover fotos atuais para poder acrescentar novas
            fotos.
          </vs-alert>
        </div>

        <!-- Footer -->
        <div class="flex justify-end gap-5">
          <!-- Botão Escolher Arquivo -->
          <vs-button
            @click="openEscolhaArquivoUpload(idReferente)"
            :disabled="listArquivosToUpload.length + listArquivos.length >= 40"
            color="warning"
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="PlusIcon" />Escolher arquivos
            </div></vs-button
          >
          <input
            :id="`fileUpload${idReferente}${idTerceiro}`"
            type="file"
            accept="image/*,.pdf"
            @change="selectArquivoUpload"
            name="files"
            hidden
            multiple
            enctype="multipart/form-data"
          />

          <!-- Botão Upload -->
          <vs-button
            @click="uploadArquivosSelecionados()"
            :disabled="
              listArquivosToUpload.length + listArquivos.length > 40 ||
              !listArquivosToUpload.length
            "
          >
            <div class="flex items-center gap-2">
              <feather-icon icon="UploadIcon" />Upload:
              {{ listArquivosToUpload.length }} arquivos selecionados
            </div></vs-button
          >
        </div>
      </Modal>
      <!-- ######### END MODAIS #########-->
    </div>
  </vs-card>
</template>

<script>
import jwt from 'jsonwebtoken';
import moment from 'moment';

import service from '../../../../../services';
import notify from './../../../../../utils/notify';
import Modal from '../../../../../components/Modal.vue';

export default {
  props: {
    formData: Object,
    arquivos: Array,
    idReferente: Number,
    title: {
      type: String,
      default: 'Cadastrar Fotos e Documentos',
    },
  },
  components: { Modal },
  data() {
    return {
      showComponent: true,
      idEvento: null,
      idTerceiro: null,
      idUsuario: null,
      modalFotoAtivo: false,
      modalUploadAtivo: false,
      titleModalUpload: null,
      itemModalSelecionado: null,
      listArquivosToUpload: [],
      listArquivosToDelete: [],
      listArquivos: [],

      files: [],
    };
  },
  watch: {
    formData(value) {
      this.idEvento = value.idEvento;
      this.idTerceiro = value.idTerceiro || null;
    },
    arquivos(value) {
      this.listArquivos = value;
    },
  },
  methods: {
    openModalDetalhes(arquivo) {
      this.modalFotoAtivo = true;
      this.itemModalSelecionado = arquivo;
    },
    openModalUpload(idReferente) {
      this.modalUploadAtivo = true;
      this.titleModalUpload = 'Upload de Fotos e Documentos';

      switch (idReferente) {
        case 1:
          this.titleModalUpload += ' - Dados Gerais';
          break;

        case 2:
          this.titleModalUpload += ' - Reparo do Veículo';
          break;

        case 3:
          this.titleModalUpload += ' - Terceiros';
          break;
      }
    },
    openEscolhaArquivoUpload() {
      document
        .getElementById(`fileUpload${this.idReferente}${this.idTerceiro}`)
        .click();
    },
    selectArquivoUpload(event) {
      const fileList = event.target.files;

      if (!fileList.length) {
        return;
      }

      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        this.listArquivosToUpload.push({
          legenda: this.getNomeArquivoSemExtensao(file.name),
          url: URL.createObjectURL(file),
          nome: file.name,
        });
        this.files.push(file);
      }
    },
    getNomeArquivoSemExtensao(nomeArquivo) {
      const ultimoPontoIndex = nomeArquivo.lastIndexOf('.');

      if (ultimoPontoIndex !== -1) {
        return nomeArquivo.substring(0, ultimoPontoIndex);
      }

      return nomeArquivo;
    },
    isPdf(urlArquivo) {
      const ext = urlArquivo.split('.').pop();

      return ext === 'pdf' ? true : false;
    },
    updateLegendaArquivo(arquivo, novaLegenda) {
      arquivo.legenda = novaLegenda;
    },
    deleteArquivoUpload(index) {
      this.listArquivosToUpload.splice(index, 1);

      const deletedFile = this.listArquivosToUpload[index];
      const fileIndex = this.files.findIndex(
        (file) => file.name === deletedFile.nome,
      );

      if (fileIndex !== -1) {
        this.files.splice(fileIndex, 1);
      }
    },
    selectArquivoToDelete(arquivoSelecionado) {
      arquivoSelecionado.deletar = true;
      this.listArquivosToDelete.push(arquivoSelecionado);
    },
    undoArquivoToDelete(arquivoSelecionado) {
      delete arquivoSelecionado.deletar;

      const index = this.listArquivosToDelete.findIndex(
        (item) => item.idArquivo === arquivoSelecionado.idArquivo,
      );

      if (index !== -1) {
        this.listArquivosToDelete.splice(index, 1);
      }
    },
    async registraArquivosUpload(files, listArquivosToUpload) {
      try {
        const listFiles = [];

        files.forEach((file, index) => {
          listFiles.push({
            idEvento: this.idEvento,
            idTerceiro: this.idTerceiro,
            idFotoReferente: this.idReferente,
            nome: file,
            legenda: listArquivosToUpload[index].legenda,
            uploadBy: this.idUsuario,
          });
        });

        const result = await service.post(
          'eventos2',
          'registrar-fotos-documentos',
          listFiles,
        );

        // POG
        setTimeout(() => {
          this.listArquivos = result.data;
        }, 500);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async uploadArquivosSelecionados() {
      try {
        this.$vs.loading();

        const formDataSend = new FormData();

        this.files.forEach((file) => {
          formDataSend.append('files', file);
        });

        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          'Eventos/' + this.idEvento,
          formDataSend,
        );

        await this.registraArquivosUpload(
          uploadedFiles,
          this.listArquivosToUpload,
        );

        this.modalUploadAtivo = false;
        this.listArquivosToUpload = [];
        this.files = [];
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível subir os arquivos');
      } finally {
        this.$vs.loading.close();
      }
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');

      if (token) {
        const decoded = jwt.decode(token);
        this.idUsuario = decoded.id_usuario;
      }
    },
    async deleteRegistroArquivos() {
      try {
        this.$vs.loading();

        const objSend = {
          idEvento: this.idEvento,
          idTerceiro: this.idTerceiro,
          idFotoReferente: this.idReferente,
          ids: [],
        };

        this.listArquivosToDelete.forEach((file) => {
          if (file.deletar) {
            objSend.ids.push(file.idEventoFoto);
          }
        });

        const result = await service.post(
          'eventos2',
          'deletar-fotos-documentos',
          objSend,
        );

        this.listArquivos = result.data;
      } catch (error) {
        notify.notifyFail(this.$vs, 'Não foi possível deletar os arquivos');
      } finally {
        this.listArquivosToDelete = [];
        this.$vs.loading.close();
      }
    },
    formatDateHour(value) {
      if (!value) {
        return '';
      }

      return moment(value).format('DD/MM/YYYY HH:mm');
    },
  },
  mounted() {
    this.getDecoded();

    this.idEvento = this.formData.idEvento;
    this.idTerceiro = this.formData.idTerceiro || null;
    this.listArquivos = this.arquivos;
  },
};
</script>

<style>
.colorBlue {
  color: #00bfed;
}

.remove {
  background-color: rgb(252 165 165);
  color: black;
}
</style>
